import {Component, Input} from "@angular/core";

@Component({
  selector: 'db-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
  standalone: true,
})
export class LoadingSpinnerComponent {

  @Input() size: number;
  @Input() centered: boolean;
  @Input() darkColor?: boolean = false;

}
